import { StateUtils } from '@spartacus/core';
import { TrackingDeliveryApi } from '@tracking/const';
import { TRACKING_DELIVERY } from '../tracking-state';

export const LOAD_TRACKING_DELIVERY = '[Tracking] Tracking Delivery Load';
export const LOAD_TRACKING_DELIVERY_SUCCESS = '[Tracking] Tracking Delivery Load Success';
export const LOAD_TRACKING_DELIVERY_FAIL = '[Tracking] Tracking Delivery Load Fail';
export const TRACKING_DELIVERY_RESET = '[Tracking] Tracking Delivery Reset';

export class TrackingDeliveryLoad extends StateUtils.EntityLoadAction {
  readonly type = LOAD_TRACKING_DELIVERY;

  constructor(public trackingId: string) {
    super(TRACKING_DELIVERY, trackingId);
  }
}

export class TrackingDeliveryLoadFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_TRACKING_DELIVERY_FAIL;

  constructor(
    public trackingId: string,
    public payload: any,
  ) {
    super(TRACKING_DELIVERY, trackingId, payload);
  }
}

export class TrackingDeliveryLoadSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_TRACKING_DELIVERY_SUCCESS;

  constructor(
    public trackingId: string,
    public payload: TrackingDeliveryApi,
  ) {
    super(TRACKING_DELIVERY, trackingId, payload);
  }
}

export class TrackingDeliveryReset extends StateUtils.EntityLoaderResetAction {
  readonly type = TRACKING_DELIVERY_RESET;

  constructor(public trackingId: string) {
    super(TRACKING_DELIVERY, trackingId);
  }
}
